import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Field } from '@cordata/buffet';

const options = [
  'Appointment',
  'Surgery',
  'Procedure',
  'Testing',
].map(o => ({
  label: o,
  value: o,
}));

const EventTypeNameField = () => {
  const { setFieldValue, values: { eventTypeName, eventTypeNameSelect } } = useFormikContext();

  useEffect(() => {
    setFieldValue('eventTypeNameSelect', eventTypeName && { value: eventTypeName, label: eventTypeName });
  }, []);

  useEffect(() => {
    setFieldValue('eventTypeName', (eventTypeNameSelect || {}).value);
  }, [eventTypeNameSelect]);

  return (
    <Field
      name="eventTypeNameSelect"
      label="Event Type Name"
      type="select"
      options={options}
    />
  );
};

export default EventTypeNameField;
